const images = {
    logo: require('~/assets/images/logo.svg'),
};

export default images;
